export const ErrorMessage =
  'システムエラーで処理に失敗しました。お困りの場合はユーザーサポートまでお問い合わせお願いたします。';
